import type { GameState } from '../core/GameState';
import type { EventBus } from '../core/EventBus';
import { RULES, SCORING } from '../constants';

export class CorrectionSystem {
  private state: GameState;
  private events: EventBus;

  constructor(state: GameState, events: EventBus) {
    this.state = state;
    this.events = events;
  }

  update(dt: number): void {
    // Tick down cooldowns
    for (const agent of this.state.agents) {
      if (agent.correctionCooldown > 0) {
        agent.correctionCooldown = Math.max(0, agent.correctionCooldown - dt);
      }
    }
  }

  correctAgent(agentId: string): boolean {
    const agent = this.state.agents.find(a => a.id === agentId);
    if (!agent) return false;
    if (agent.status === 'crashed') return false;
    if (agent.drift < 0.05) return false; // nothing to correct
    if (agent.correctionCooldown > 0) return false;

    const driftAtCorrection = agent.drift;

    // Apply correction — effectiveness depends on drift level
    let reduction: number;
    if (driftAtCorrection > 0.85) {
      // Too late — partial effect
      reduction = RULES.lateCorrection85Reduction;
    } else {
      reduction = RULES.correctionDriftReduction;
    }

    agent.drift = Math.max(0, agent.drift - reduction);
    agent.correctionCooldown = this.state.difficulty.correctionCooldown;

    // Track CE KPI
    this.state.totalCorrections++;
    if (driftAtCorrection >= SCORING.optimalDriftMin && driftAtCorrection <= SCORING.optimalDriftMax) {
      this.state.optimalCorrections++;
    }
    this.state.updateCE();

    this.events.emit('agent:corrected', { agentId, driftAtCorrection });
    return true;
  }
}
